export default {
  state: {
    // last User state
    userState: {
      userStateId: null,
      userUuid: null,
      params: null
    },
    solutions: [],
    exports: [] // Exported app,game etc.
  },
  getters: {
    hasUserState(state) {
      return state.userState.userUuid !== null;
    },
    lastUserSolution(state) {
      return state.solutions;
    },
    lastUserSolutionPageNumber(state) {
      const sorted = state.solutions.sort(
        (s1, s2) => s2.pageNumber - s1.pageNumber
      );
      if (sorted && sorted.length) {
        return sorted[0].pageNumber;
      }
    },
    canUserDownload(state, getters, rootState, rootGetters) {
      const isRunningMode = rootGetters['workspace/session/isRunningMode'];
      const isTutorialFinished =
        rootGetters['workspace/session/isTutorialFinished'];
      // @todo user finished the app.
      return isRunningMode && isTutorialFinished;
    }
    // @todo get ios exports
    // @todo get android exports
  },
  mutations: {
    importUserState(state, userState) {
      state.userState.userStateId = userState?.userStateId;
      state.userState.userUuid = userState?.userUuid;
      if (typeof userState?.params === 'object')
        state.userState.params = userState?.params;
      else state.userState.params = JSON.parse(userState?.params);
    },
    importUserSolutions(state, solutions) {
      state.solutions.push(...solutions);
    }
    // @todo mutate exports.
  },
  actions: {
    fetchUserStateByUser(action, tutorialId) {
      const { commit, rootGetters, rootState } = action;
      return rootGetters['CodementumUser/apiRequest']({
        method: 'get',
        path: '/userstates/me',
        opt: {
          baseURL: rootGetters['workspace/mainApi']
        },
        onSuccess(data) {
          commit('importUserState', data);
        }
      });
    },
    addUserStateByUser(action, params) {
      const { state, getters, rootGetters } = action;

      let paramsToSave = params;
      if (typeof params !== 'string') paramsToSave = JSON.stringify(params);

      return rootGetters['CodementumUser/apiRequest']({
        method: 'post',
        path: '/userstates',
        body: {
          params: paramsToSave
        },
        opt: {
          baseURL: rootGetters['workspace/mainApi']
        },
        onSuccess(data) {
          console.log('solutions:', data);
          // commit("importUserState", data?.list[0]);
        }
      });
    },
    patchUserStateByUser(action, params) {
      // implement
    },
    saveUserStateByUser(action, params) {
      const { dispatch, state, getters } = action;
      if (getters.hasUserState) {
        dispatch('patchUserStateByUser', params);
      } else dispatch('addUserStateByUser', params);
    },
    fetchSolutionsByUser(action, tutorialId) {
      const { commit, rootGetters, rootState } = action;
      return rootGetters['CodementumUser/apiRequest']({
        method: 'get',
        path: '/solutions/me',
        body: {
          params: {
            search: 'page.tutorial.id==' + tutorialId
          }
        },
        opt: {
          baseURL: rootGetters['workspace/mainApi']
        },
        onSuccess(data) {
          if (data.totalCount) commit('importUserSolutions', data.list);
        }
      });
    },
    addTheSolutionsByUser(action) {
      const { commit, rootGetters, rootState } = action;

      const { timeSpent, startedAt, finishedAt, numberOfAttempts } =
        rootState.workspace.session.tutorial.activeMission;
      const type = rootGetters['workspace/tutorial/getPageByPageNumber'](
        rootGetters['workspace/session/showingPageNumber']
      ).type;

      return rootGetters['CodementumUser/apiRequest']({
        method: 'post',
        path: '/solutions',
        body: {
          type,
          solution: JSON.stringify(rootGetters['workspace/session/appJson']),
          // star: 2,
          timeSpent,
          startedAt,
          finishedAt,
          numberOfAttempts,
          // userUuid: ,
          pageNumber: rootGetters['workspace/session/showingPageNumber'],
          pageId: rootGetters['workspace/session/showingPage'].pageId,
          tutorialId: rootState.workspace.tutorial.tutorialId
        },
        opt: {
          baseURL: rootGetters['workspace/mainApi']
        },
        onSuccess(data) {
          commit('importUserSolutions', [data]);
        }
      });
    },
    addStat(action, actionType) {
      if (!actionType) throw new Error('no actionType');

      const { state, getters, rootGetters, rootState } = action;

      var productType;
      if (rootGetters['workspace/mainApi'].includes('appmaker'))
        productType = 'APPMAKER';
      if (rootGetters['workspace/mainApi'].includes('gamemaker'))
        productType = 'GAMEMAKER';
      if (rootGetters['workspace/mainApi'].includes('aiml'))
        productType = 'AIML';

      return rootGetters['CodementumUser/apiRequest']({
        method: 'post',
        path: '/maker-stats',
        body: {
          productType,
          actionType,
          tutorialId: rootState.workspace.tutorial.tutorialId,
          pageId: rootGetters['workspace/session/showingPage'].pageId
        }
      });
    }
  }
};
